// Routes.
import { PATH_WEBPAGE } from "./routes/paths";


// ---------------------------------------------------------

// Default root path.
export const DEFAULT_PATH = PATH_WEBPAGE.general.home; // as "/home"